import React from 'react';

import getIconByType from '../../../getIconByType';
import getTitleByType from '../../../getTitleByType';
import {getDateByCustomFormat, DATE_FORMATS} from 'utils/date';
import {Layout, Text, WarningIcon} from '@phonectas/unifon-ui-kit';
import EventDescription from '../EventDescription';
import {EventData} from './types';

const ThreeSixtyIncident: React.FC<EventData> = ({data}) => {
	const isWarning = data?.is_warning;

	return (
		<Layout gap="sm" fullWidth nowrap fullHeight>
			<Layout direction="column" nowrap gap="md" alignItems="center" style={{width: '42px'}}>
				<Layout>
					{getIconByType(data.feed_type)}
				</Layout>
				<Layout>
					{
						isWarning && (
							<Layout>
								<WarningIcon color="warning" />
							</Layout>
						)
					}
				</Layout>
			</Layout>
			<Layout direction="column" fullWidth nowrap>
				<Layout direction="row" fullWidth nowrap>
					<Layout direction="column" fullWidth nowrap gap="xs">
						<Layout direction="row" gap="xs" fullWidth alignItems="center" justifyContent="space-between">
							<Text variant="h3">{getTitleByType(data?.feed_type)}</Text>
							<Text color="textSecondary" variant="body1">
								{
									getDateByCustomFormat(data?.created_at, DATE_FORMATS.DD_MM_YY_HH_mm)
								}
							</Text>
						</Layout>
						<Layout fullWidth direction="row" nowrap>
							<Layout fullWidth gap="none">
								<Layout
									direction="row"
									justifyContent="space-between"
									fullWidth
									alignItems="center"
									gap="none"
								>
									<Text color="textSecondary" style={{alignItems: 'center'}} variant="body1">
										{data?.data_fields?.actor_name}
									</Text>
								</Layout>
							</Layout>
						</Layout>
						<Layout direction="row" gap="xs" fullWidth alignItems="center" justifyContent="space-between">
							<Text color="textSecondary" variant="body1">
								{data?.data_fields?.main_category}
							</Text>
							<Text color="textSecondary" variant="body1">
								{data?.data_fields?.sub_category}
							</Text>
						</Layout>
						<Layout direction="row" nowrap>
							<EventDescription
								description={data?.data_fields?.body}
							/>
						</Layout>
						<Layout direction="row" fullWidth style={{gap: '8px'}}>
						</Layout>
					</Layout>
				</Layout>
			</Layout>
		</Layout>
	);
}

export default ThreeSixtyIncident;
